<template>
  <div class="popup">
    <Modal v-model:show="show" :show-close="true" class="popup-modal">
      <div class="information-content discount-message-container">
        <div class="discount-message">
          <template v-if="discount && discount.isActive">
            <h1 class="light">{{ discount.name }}</h1>
            <p>
              {{ getMessage() }}
            </p>
          </template>
          <template v-else-if="discount && !discount.isActive">
            <h1 class="light">{{ discount.name }}</h1>
            <p>
              <span>Thanks for stopping by. This promotion has now ended.</span>
              <br />
              <span>Don't let that deter you though, our products offer outstanding value everyday.</span>
            </p>
          </template>
          <template v-else>
            <h1 class="light">SORRY</h1>
            <p>WE COULDN'T FIND THE DISCOUNT YOU ARE LOOKING FOR.</p>
          </template>
          <div v-if="displayShopNowButton">
            <button class="button filled coral" @click="onCloseClicked()">Shop Now</button>
          </div>
          <div v-else-if="displayCloseButton">
            <button class="button filled coral" @click="onCloseClicked()">Close</button>
          </div>
          <div v-else>
            <button v-if="displayRegisterButton" class="button register filled coral" @click="onRegisterClicked()">Register now</button>
            <button class="button secondary" @click="onLoginClicked()">Login</button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/pixel/index';
import useCommon from '@/compositions/useCommon';
import useDiscount from '@/compositions/useDiscount';

const CAMPAIGN_TYPES = [
  { name: 'B2B_TRADE', registerPage: 'tradeSignUp'},
  { name: 'B2C', registerPage: 'login'},
  { name: 'B2B_BUSINESS', registerPage: 'businessSignUp'},
];

export default {
  name: 'DiscountPopup',
  components: {
    Modal,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    displayShopNowButton() {
      const { discountEligibility, discountCampaignType } = this.discount ?? {};
      return discountCampaignType === 'B2C' && (this.isVerifiedUser || discountEligibility === 'NONE');
    },
    displayCloseButton() {
      const { discountCampaignType } = this.discount ?? {};
      return discountCampaignType !== 'B2C' && this.isVerifiedUser;
    },
    displayRegisterButton() {
      const { discountEligibility } = this.discount ?? {};
      return discountEligibility !== 'LOGIN' && !this.isVerifiedUser;
    }
  },
  setup() {
    const { discount } = useDiscount();
    const { urls, isVerifiedUser } = useCommon();

    return {
      discount,
      urls,
      isVerifiedUser
    };
  },
  created() {
    if (this.$route.params.discount) {
      this.show = true;
    }
  },
  methods: {
    onCloseClicked() {
      this.show = false;
    },
    onRegisterClicked() {
      this.onCloseClicked();
      const campaign = CAMPAIGN_TYPES.find(c => c.name === this.discount.discountCampaignType) || {};
      this.$router.push({name: campaign.registerPage || 'login', query: this.$route.query});
    },
    onLoginClicked() {
      this.onCloseClicked();
      this.$router.push({name: 'login'});
    },
    getMessage() {
      if (this.isVerifiedUser && this.discount.loggedInMessage) {
        return this.discount.loggedInMessage;
      }
      return this.discount.message;
    }
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.popup {

  .discount-message-container {
    max-width: 600px;
    margin: auto;

    .discount-animation {
      background: var(--white);
    }

    .discount-message {

      h1{
        margin: 0 16px 16px 0;
      }

      p {
        margin-bottom: 16px;
      }

      #discount-terms {
        display: block;
        text-decoration: underline;
      }
    }

    button.register {
      margin-right: 16px;
    }
  }
}
</style>
